import React from 'react';
import { Card, Flex, Text, Grid } from '@radix-ui/themes';
import { CubeIcon } from '@radix-ui/react-icons';

import * as Types from '../../../../../types';
import { WorkflowNodeProps } from '../..';

const ABIDecoderNode = ({
  id,
  data,
  onChange,
}: WorkflowNodeProps<Types.TransformerNode>) => (
  <Grid columns="1" gap="2">
    <Flex align="center" gap="2" mb="2">
      <CubeIcon />
      <Text as="div" size="2" weight="bold">
        ABI Decoder
      </Text>
    </Flex>
    <Card variant="ghost" mt="2">
      <Flex justify="between">
        <Text size="1" color="gray">
          (Details Not Implemented)
        </Text>
        {data.transformer.name}
      </Flex>
    </Card>
  </Grid>
);

export default ABIDecoderNode;
